import { ReactNode } from "react";

import { SECONDARY_COLOR } from "@hl/base-components/lib/theme/button";
import { STATUS_COLOR } from "@hl/base-components/lib/theme/colors";
import { FulfillAuction } from "@hl/shared-features/lib/features/auction-manager";
import {
  Button,
  Card,
  Group,
  Stack,
  Switch,
  Text,
  useMantineTheme,
} from "@mantine/core";

import {
  SaleStatus,
  getStartsInLabel,
} from "~/features/tokens/sections/ManageToken/types";

import { saleTitleMap } from "../MintVector/MultipleMintVector";
import { GetManageTokenAuctionsQuery } from "../queries.graphql.generated";

export interface SaleConfig {
  mintStatus: string;
  hasStarted?: boolean;
  description?: string;
  color: string;
  icon: ReactNode;
}

//TODO: update to proper types here
/* eslint-disable  @typescript-eslint/no-explicit-any */
export interface AuctionData {
  collectionId: string;
  auction: GetManageTokenAuctionsQuery["getAuctionsByCollection"][0];
  refetchCollection: any;
  refetchAuction: any;
}

const SaleStatusBox = ({
  saleConfig,
  editButton,
  showEditButton,
  showFulfillAuctionButton,
  auctionData,
  onEditSaleClick,
  startDate,
  isSalePaused,
  onTogglePauseSaleClick,
  withBorder = false,
  loading = false,
  error,
}: {
  saleConfig: SaleConfig;
  editButton?: string;
  showEditButton: boolean;
  showFulfillAuctionButton?: boolean;
  auctionData?: AuctionData;
  onEditSaleClick?: () => void;
  startDate: Date;
  withBorder?: boolean;
  isSalePaused?: boolean;
  onTogglePauseSaleClick?: () => void;
  loading?: boolean;
  error?: string;
}) => {
  const theme = useMantineTheme();
  const showPauseButton = onTogglePauseSaleClick != null;
  // When we can toggle the paused state of the sale, the saleConfing we are getting
  // will ignore the paused state, so we can show the correct sale state after unpausing.
  // Thats why we override it oursevles here.
  const overridenSaleConfig =
    isSalePaused && showPauseButton
      ? saleTitleMap[SaleStatus.PAUSED]
      : saleConfig;
  console.log(overridenSaleConfig, isSalePaused && showPauseButton);
  const saleStatusColor = theme.fn.themeColor(overridenSaleConfig.color);
  const saleTimingDescription = overridenSaleConfig.mintStatus.replace(
    ":days",
    getStartsInLabel(startDate)
  );

  const refetchData = () => {
    auctionData?.refetchCollection();
    auctionData?.refetchAuction();
  };

  return (
    <Card p={16} withBorder={withBorder}>
      <Group position="apart">
        <Group
          spacing={8}
          sx={{
            color: saleStatusColor,
          }}
          align="center"
        >
          {overridenSaleConfig.icon}
          <Stack spacing={0}>
            <Text
              weight={500}
              size="lg"
              style={{ wordWrap: "break-word" }}
              color={saleStatusColor}
            >
              {saleTimingDescription}
            </Text>
            {overridenSaleConfig.description && (
              <Text size="xs" color={saleStatusColor}>
                {overridenSaleConfig.description}
              </Text>
            )}
          </Stack>
        </Group>
        {showEditButton && (
          <Stack spacing={8}>
            <Button
              size="sm"
              loading={loading}
              color={SECONDARY_COLOR}
              onClick={onEditSaleClick}
            >
              {editButton}
            </Button>
            {error && (
              <Text size="xs" align="center" color={STATUS_COLOR.ERROR}>
                {error}
              </Text>
            )}
            <Text size="xs" align="center">
              This action requires a transaction
            </Text>
          </Stack>
        )}
        {showPauseButton && (
          <Switch
            mt={4}
            checked={!isSalePaused}
            onChange={onTogglePauseSaleClick}
          />
        )}
        {showFulfillAuctionButton && auctionData && (
          <FulfillAuction
            auctionId={auctionData?.auction.id ?? undefined}
            chainId={auctionData?.auction.chainId ?? 1}
            collectionId={auctionData.collectionId}
            refetchData={refetchData}
            fulfillerIsOwner={true}
          />
        )}
      </Group>
    </Card>
  );
};

export default SaleStatusBox;
